export default __webpack_public_path__ + "static/6_33-bcd7039e0f154cae7dc851899e47be7d.png";